"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepCompare = void 0;

var isEmpty_1 = __importDefault(require("lodash/isEmpty"));

var isEqual_1 = __importDefault(require("lodash/isEqual"));

var xorWith_1 = __importDefault(require("lodash/xorWith"));
/**
 *
 *
 * @export
 * @param {object[]} arr1
 * @param {object[]} arr2
 * @returns {boolean}
 */


function deepCompare(arr1, arr2) {
  return isEmpty_1.default(xorWith_1.default(arr1, arr2, isEqual_1.default));
}

exports.deepCompare = deepCompare;